// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I7mn1Cl1TDZ4qz4i6Ro_ {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}
.I7mn1Cl1TDZ4qz4i6Ro_:hover, .I7mn1Cl1TDZ4qz4i6Ro_:focus {
  color: #0056b3;
  outline: none;
}

.hArHsuP_GWxsZkvgxX2u {
  color: #999;
  text-decoration: underline;
  cursor: not-allowed;
}
.hArHsuP_GWxsZkvgxX2u:hover, .hArHsuP_GWxsZkvgxX2u:focus {
  color: #999;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/toggle-link/toggle-link.module.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;EAEA,kCAAA;AADF;AAGE;EAEE,cAAA;EACA,aAAA;AAFJ;;AAMA;EACE,WAAA;EACA,0BAAA;EACA,mBAAA;AAHF;AAKE;EAEE,WAAA;AAJJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.toggle-link {\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n\n  transition: color 0.2s ease-in-out;\n\n  &:hover,\n  &:focus {\n    color: #0056b3;\n    outline: none;\n  }\n}\n\n.toggle-link-disabled {\n  color: #999;\n  text-decoration: underline;\n  cursor: not-allowed;\n\n  &:hover,\n  &:focus {\n    color: #999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle-link": `I7mn1Cl1TDZ4qz4i6Ro_`,
	"toggle-link-disabled": `hArHsuP_GWxsZkvgxX2u`
};
export default ___CSS_LOADER_EXPORT___;
